import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { UsersService, BackendInterceptor, NavigationConfig } from 'gung-standard';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarLinerUsersService extends UsersService {
  constructor(
    protected http: HttpClient,
    protected backendInterceptor: BackendInterceptor,
    @Optional()
    @Inject('environment')
    protected environment: NavigationConfig
  ) {
    super(http, backendInterceptor, environment);
  }

  getDefaultUserRoles() {
    return of([
      { selected: false, id: 'ACTUATOR' },
      { selected: false, id: 'ADMIN' },
      { selected: false, id: 'SALES' },
      { selected: false, id: 'DISTRIBUTOR' },
      { selected: false, id: 'USER' },
      { selected: false, id: 'ORDER' },
      { selected: false, id: 'MFA_REQUIRED' },
      { selected: false, id: 'END_USER' }
    ]);
  }
}
